import { MessageSquare, Phone } from "lucide-react";
import { telHref, smsHref } from "@/lib/device";

export function PhoneActions({ phone, testId = "phone", icon = true }) {
  if (!phone) return <span>—</span>;
  return (
    <span className="inline-flex items-center gap-2 flex-wrap">
      <a href={telHref(phone)} data-testid={`${testId}-call`} className="font-medium text-[#8E5276] hover:underline inline-flex items-center gap-1" title="Call">{icon && <Phone className="h-3.5 w-3.5" />}{phone}</a>
      <a href={smsHref(phone)} data-testid={`${testId}-sms`} className="inline-flex items-center gap-1 text-[11px] px-2 py-1 rounded-full bg-emerald-50 text-emerald-700 hover:bg-emerald-100" title="Send a text message"><MessageSquare className="h-3 w-3" />Text</a>
    </span>
  );
}

export const waLink = (phone) => `https://wa.me/${(phone || "").replace(/\D/g, "").replace(/^(\d{10})$/, "1$1")}`;

export function SmsTag({ ok, phone, channels }) {
  const ch = channels ?? (ok === null || ok === undefined ? null : ok ? ["sms"] : []);
  if (ch === null) return null;
  if (ch.length === 0) return <span data-testid="sms-not-capable-tag" className="inline-flex items-center gap-1 text-[10px] px-1.5 py-0.5 rounded-full bg-gray-100 text-gray-500"><MessageSquare className="h-3 w-3" />No SMS / WhatsApp</span>;
  return <>
    {ch.includes("sms") && <a href={smsHref(phone)} data-testid="sms-capable-tag" className="inline-flex items-center gap-1 text-[10px] px-1.5 py-0.5 rounded-full bg-emerald-50 text-emerald-700 hover:bg-emerald-100" title="Send a text message"><MessageSquare className="h-3 w-3" />SMS · Text</a>}
    {ch.includes("whatsapp") && <a href={waLink(phone)} target="_blank" rel="noreferrer" data-testid="whatsapp-capable-tag" className="inline-flex items-center gap-1 text-[10px] px-1.5 py-0.5 rounded-full bg-[#DCF8C6] text-[#075E54] hover:brightness-95" title="Open WhatsApp chat"><MessageSquare className="h-3 w-3" />WhatsApp</a>}
  </>;
}
